import { memo } from 'react';

const Divider = () => <span className="fm-ee__editorToolbarDivider" />;

export default memo(Divider);
